import { ImSpinner8 } from "react-icons/im";

const Icon = () => (
  <div>
    <ImSpinner8
      className="animate-spin text-cyan-500"
      size="24"
    />
  </div>
);

export default Icon;
